var path = 'app/scripts/modules/google/src/loadBalancer/configure/tcp/listener.html';
var html = "<div class=\"container-fluid form-horizontal\">\n  <ng-form name=\"listenerForm\">\n    <div class=\"form-group\">\n      <div class=\"col-md-4 sm-label-right\">\n        Port\n      </div>\n      <div class=\"col-md-4\">\n        <select class=\"form-control input-sm\"\n                ng-options=\"port for port in ctrl.portOptions\"\n                ng-disabled=\"!ctrl.isNew\"\n                ng-model=\"ctrl.loadBalancer.portRange\">\n        </select>\n      </div>\n    </div>\n  </ng-form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/loadBalancer/configure/tcp/listener.html
// module id = 1285
// module chunks = 0